import React from 'react';
import {
  FDLozenge, FDPaper, FDStack, FDTitleText,
} from '@facet-wealth/design';
import MetaControlField from 'Components/UI/Meta/MetaForm/Components/MetaControlField';
import { PrimaryActionButtonRel } from 'Packages/FacetCore/Experimental/RelationshipComponents/PrimaryActionButtonRel';
import fr from 'facet-rest';
import { dataAttrs } from 'Helpers/Testing';
import useMetaLayoutContext from 'Components/UI/Meta/MetaForm/Components/MetaLayoutContext';
import { Text } from 'Packages/FacetDesign/Components/Text';
import { buildFacetDesignOverride, overrideReadOnly } from 'Packages/FacetRest/FacetDesignOverride';

export const filingBoxMetaOverrideSet = buildFacetDesignOverride()
  .nameOverride('title', {
    _component: () => Text,
    _customProps: { Component: FDTitleText, size: 'lg' },
  }, overrideReadOnly);

export const FilingBox = () => {
  const { resource } = useMetaLayoutContext();
  const actionButton = resource.withRelationship(fr.relationships.main.name,
    (rel) => (
      <PrimaryActionButtonRel
        relationship={rel}
        size={'md'}
        {...dataAttrs('tax-dashboard-filing-hero-button')}
      />
    ),
    () => null);

  return (
    <FDPaper>
      <FDStack direction={'column'} padding={2} spacing={1}>
        <FDLozenge
          label={resource.attr('label')}
          color={'info'}
        />
        <MetaControlField attr="title" />
        {actionButton}
      </FDStack>
    </FDPaper>
  );
};
